import { useState } from "react";

const faqs = [
  {
    q: "What does Fist Limited sell?",
    a: "Fist Limited is a technology retailer in Liverpool selling mobile phones, smartphones, laptops and everyday technology accessories including chargers, cables, phone cases, headsets, Bluetooth speakers and earphones.",
  },
  {
    q: "Where is Fist Limited located?",
    a: "The shop is at 86 Eastdale Road, Liverpool, L15 4HW. You can also find our range at our market stall, and reach us on 07909 324302.",
  },
  {
    q: "How do I enquire about a product?",
    a: "Send us an email at fistlimited007@gmail.com, or call 07909 324302. We'll confirm availability and help you find the right product before you visit.",
  },
  {
    q: "Do you sell at market stalls?",
    a: "Yes. Fist Limited brings mobiles, laptops and everyday technology accessories directly to customers through market stalls. Follow us to see where we're trading next.",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-foreground-50 py-20 md:py-24">
      <div className="container-x max-w-3xl">
        <div className="mb-10 text-center">
          <p className="eyebrow mb-4">Good to Know</p>
          <h2 className="section-title">Questions, answered.</h2>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => (
            <div key={f.q} className="overflow-hidden rounded-lg border border-foreground-200 bg-background-50">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                aria-expanded={open === i}
              >
                <span className="font-heading text-base text-foreground-950">{f.q}</span>
                <i
                  className={`ri-add-line shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                    open === i ? "rotate-45" : ""
                  }`}
                ></i>
              </button>
              {open === i && (
                <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}